<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    append-to-body
    width="920px"
    :title="$l('dialog_title_chooseCharacter') || '选择特性'"
    :close-on-click-modal="false"
    :before-close="() => close()"
    v-el-dialog-drag
  >
    <Main ref="main" :chooseKeys="chooseKeys" />
    <span slot="footer">
      <el-button size="small" @click="close()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="confirm()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    chooseKeys: { type: Array, default: () => [] },
  },
  methods: {
    confirm() {
      const data = this.$refs.main.getCheckboxRecords()
      this.$emit('confirm', data || [])
      this.close()
    },
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
